<template>
  <div class="container">
    <template v-for="(item, index) in filters">
      <div :key="index" class="x-filter-wrapper">
        <div class="title">
          {{ item.title }}：
        </div>
        <div class="options">
          <template v-for="(xItem, xIndex) in item.options">
            <div
              :key="xIndex"
              :class="['option', ((!currentValue[xIndex] && xItem.value === item.default) || currentValue[index] === xIndex) && 'active']"
              @click="chosen(index, xIndex)">
              {{ xItem.label }}
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      currentValue: []
    }
  },
  methods: {
    chosen (index, xIndex) {
      const vm = this
      vm.$set(vm.currentValue, index, xIndex)
      vm.$emit('chosen', { key: vm.filters[index].key, value: vm.filters[index].options[xIndex].value })
    }
  }
}
</script>

<style scoped lang="less">
  .container {
    .x-filter-wrapper {
      display: flex;
      font-size: 14px;
      color: #333;
      margin-bottom: 20px;
      .title {
        margin-right: 30px;
        white-space: nowrap;
      }
      .options {
        display: flex;
        flex-wrap: wrap;
        .option {
          padding: 2px 8px;
          border-radius: 4px;
          cursor: pointer;
          margin-right: 30px;
          margin-bottom: 15px;
          &.active {
            background: #c8161e;
            color: #fff;
          }
        }
      }
    }
  }
</style>
